export const PatentImageService = Symbol('PatentImageService');
